import React from "react";
import StatusIndicator from "../shared/StatusIndicator";

/**
 * Pre-phase shown while we're establishing the connection (auth bootstrap,
 * WebSocket dial, first /today round-trip). Distinguished from `LoadingState`
 * so we don't flash through "loading" → "initializing" → "warming up" in
 * rapid succession when the user lands on the page.
 */
export const ConnectingState: React.FC<{ message?: string }> = ({ message }) => (
  <div
    className="spinner-container"
    style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      height: "300px",
    }}
  >
    <StatusIndicator
      status="connecting"
      overlay={false}
      message={message ?? "establishing connection"}
    />
  </div>
);

export default ConnectingState;
